module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ResourceRegisterView.jsx"));
	}, "ResourceRegister");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ResourceRegister!./src/pages/bundle-appResource-mgmt/ResourceRegister/ResourceRegisterView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=ResourceRegister!./src/pages/bundle-appResource-mgmt/ResourceRegister/ResourceRegisterView.jsx
// module chunks = 43